import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

// Shared light-surface input used by both auth forms, so focus and
// iconography read identically to the market screens.
// `bare` drops the canvas fill and leading-icon padding, for inputs that sit
// inside a tinted group container (Wanderlog-style email/password block).
const AuthField = ({ icon: Icon, label, error, bare, pill, ...props }) => {
  const isPassword = props.type === 'password';
  const [shown, setShown] = useState(false);

  return (
    <label className="block">
      {label && (
        <span className="block mb-1.5 text-[12px] font-semibold text-ink-secondary">{label}</span>
      )}
      <span className="relative block">
        {Icon && (
          <span className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-ink-muted">
            <Icon className="w-[18px] h-[18px]" strokeWidth={1.9} />
          </span>
        )}
        <input
          {...props}
          type={isPassword ? (shown ? 'text' : 'password') : props.type}
          className={`w-full h-[50px] ${Icon ? 'pl-11' : pill ? 'pl-4' : 'pl-3.5'} ${isPassword ? 'pr-11' : 'pr-3.5'}
            text-[15px] text-ink placeholder:text-ink-muted/80 outline-none transition-colors
            ${pill ? 'rounded-full bg-white border border-gray-200 focus:border-brand-500'
              : `rounded-xl ${bare ? 'bg-transparent' : 'bg-canvas focus:bg-white focus:ring-2 focus:ring-brand-500'}`}
            ${error ? (pill ? 'border-red-400' : 'ring-1 ring-red-400') : ''}`}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShown((v) => !v)}
            aria-label={shown ? 'hide password' : 'show password'}
            className="absolute inset-y-0 right-0 pr-3.5 flex items-center text-ink-muted active:text-ink"
          >
            {shown ? <EyeOff className="w-[18px] h-[18px]" /> : <Eye className="w-[18px] h-[18px]" />}
          </button>
        )}
      </span>
    </label>
  );
};

export default AuthField;
